import { render, staticRenderFns } from "./CardComponent.vue?vue&type=template&id=55bb7fd8"
import script from "./CardComponent.vue?vue&type=script&lang=js"
export * from "./CardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jorgerebelo/Documents/Internal/corporate-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55bb7fd8')) {
      api.createRecord('55bb7fd8', component.options)
    } else {
      api.reload('55bb7fd8', component.options)
    }
    module.hot.accept("./CardComponent.vue?vue&type=template&id=55bb7fd8", function () {
      api.rerender('55bb7fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/wp-content/themes/kwankotheme/assets/js/components/campaigns_directory/CardComponent.vue"
export default component.exports